module.exports = __webpack_public_path__ + "img/europe_map.b173d39.png";